import * as actionTypes from "./actionTypes";

export const apiStart = show => {
  return {
    type: actionTypes.API_START,
    show,
  };
};

export const apiSuccess = () => {
  return {
    type: actionTypes.API_SUCCESS,
  };
};

export const apiFail = error => {
  return {
    type: actionTypes.API_FAIL,
    error,
  };
};

export const clearError = () => {
  return {
    type: actionTypes.CLEAR_ERROR,
  };
};
